module.exports = __webpack_public_path__ + "img/tron (69).d4f81267.jpg";